import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../types/boolean-flag';
import type {
  HubSpotConfigurationControl,
  HubSpotConfigurationFormValues,
} from '../../HubSpotConfigurationFormSchema';
import { AUTOMATICALLY_IMPORT_CONTRACTS_OPTIONS } from './constants';

type ContractsConfigurationSectionProps = {
  control: HubSpotConfigurationControl;
  defaultValues: HubSpotConfigurationFormValues;
};

export const ContractsConfigurationSection: FC<ContractsConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Contracts" iconName="CreditCard">
    <Controller
      name="autoImportContracts"
      control={control}
      defaultValue={defaultValues.autoImportContracts}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how to import contracts from HubSpot"
          value={getFlagFromStatus(value)}
          onChange={(selected) => onChange(getStatusByFlag(selected))}
          keyExtractor={(option) => option.value}
          options={AUTOMATICALLY_IMPORT_CONTRACTS_OPTIONS}
        />
      )}
    />
  </ConfigurationSection>
);
